/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DeduplicationIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Deduplication',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="7.939" cy="6.25" r="3.75" />
    <path d="M21.506 10h-8.75l4.375-7.5 4.375 7.5z" />
    <circle cx="11.939" cy="30.25" r="3.75" />
    <path
      d="M27.603 34h-8.75l4.375-7.5 4.375 7.5zM32.121 10h-8.75l4.375-7.5 4.375 7.5zM27.939 12.058h-20v1.222a1.514 1.514 0 0 0 .723 1.3l5.689 4.02a3.056 3.056 0 0 1 1.114 2.377v4.193a.733.733 0 0 0 .714.75H19.7a.733.733 0 0 0 .714-.75v-4.194a3.056 3.056 0 0 1 1.113-2.376l5.689-4.015a1.514 1.514 0 0 0 .723-1.3Z"
    />
  </svg>`;
};
